export enum DeploymentDownloadType {
    Source = 'source',
    Output = 'output',
}